import { Box, Checkbox, Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/components/Text";

interface ReportAcknowledgmentSectionProps {
  workerFirstName?: string;
  acknowledged: boolean;
  onAcknowledgedChange: (acknowledged: boolean) => void;
}

export function ReportAcknowledgmentSection(props: ReportAcknowledgmentSectionProps) {
  const { workerFirstName, acknowledged, onAcknowledgedChange } = props;

  return (
    <Box
      sx={(theme) => ({
        backgroundColor: theme.palette.background?.warning,
        border: `1px solid ${theme.palette.border?.warning}`,
        borderRadius: theme.borderRadius?.xLarge,
        padding: 4,
        marginBottom: 4,
      })}
    >
      <Stack direction="row" alignItems="flex-start" spacing={2}>
        <Checkbox
          checked={acknowledged}
          size="small"
          sx={{ padding: 0, marginTop: 0.25 }}
          onChange={(event) => onAcknowledgedChange(event.target.checked)}
        />
        <Box sx={{ flex: 1 }}>
          <Text variant="body2" sx={{ color: "warning.dark" }}>
            I understand that submitting this report may result in{" "}
            <strong>{workerFirstName ?? "the professional"}</strong> being removed from the shift,
            and if applicable, penalties being applied to their account.
          </Text>
        </Box>
      </Stack>
    </Box>
  );
}
